import React from 'react';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { GuestLanguageSelector, useGuestLanguageSelectorAvailability } from './GuestLanguageSelector';

/**
 * Guest language selector for Split View (Aloha), positioned at the top-right of the
 * layout's scroll container — which must be position:relative so the offsets resolve
 * against it. Like the Brannan header placements, it scrolls with the content rather
 * than staying pinned; only its position on the page differs.
 *
 * Renders nothing when the selector is unavailable (wedding-only, 2+ enabled
 * languages, flags on — see useGuestLanguageSelectorAvailability).
 */
export const GuestLanguageSelectorFloating: React.FC = () => {
  const isAvailable = useGuestLanguageSelectorAvailability();

  if (!isAvailable) {
    return null;
  }

  return (
    <Box
      position="absolute"
      top={pxToRem(20)}
      right={pxToRem(20)}
      zIndex="overlay"
    >
      <GuestLanguageSelector surface="floating" />
    </Box>
  );
};

GuestLanguageSelectorFloating.displayName = 'GuestLanguageSelectorFloating';
